var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "news-card-wrapper d-flex d-flex-lg-column",
      on: {
        click: function($event) {
          return _vm.navigateToNewsPost()
        }
      }
    },
    [
      _vm.imgUrl
        ? _c("img", {
            staticClass: "card-img mr-3",
            attrs: { src: _vm.imgUrl, alt: "News image" },
            on: { error: _vm.handleImgLoadError }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card-body px-0 py-0" }, [
        _vm.postData
          ? _c(
              "div",
              { staticClass: "pb-1" },
              [_c("news-card-details", { attrs: { date: _vm.postData.date } })],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "line-clamp" }, [
          _c("h4", [_vm._v(_vm._s(_vm.postData.title))])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6ce16ed0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ce16ed0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/homebase/news/NewsCard.vue
// module id = null
// module chunks = 